export default __webpack_public_path__ + "static/media/God of war.ea23649b.jpg";